import React, { useEffect, useState, useMemo } from 'react';
import { Row, Col, Typography, Avatar } from 'antd';
import { GoClock, GoLocation } from 'react-icons/go';
import moment from 'moment';
import { usePosition } from 'use-position';
import { useTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';
import { MdLocalPhone } from 'react-icons/md';
import HAND from '../../assets/images/png/hand.png';
import { getCooks } from '../../store/orders/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderState } from '../../store/orders/selector';
import { getUserState } from '../../store/user/selector';
import { arriveTimeDifference } from './components/CurrentOrders';

import Map from './components/Map';
import {
  CenterProps,
  calcCrow,
} from '../dashboard/components/DesktopMealCarousel';

export interface OrderDetailsProps {
  meal: any;
}

export const OrderDetails: React.FC<OrderDetailsProps> = ({ meal }) => {
  const { userinfo } = useSelector(getOrderState);
  const { user } = useSelector(getUserState);
  const { accountType } = user;
  const isGuest = accountType === 'i seek';
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [cooksLocation, setCooksLocation] = useState<CenterProps>();
  const settings = useMemo(
    () => ({ enableHighAccuracy: true, timeout: 0, maximumAge: Infinity }),
    []
  );

  const watch = true;
  const { latitude, longitude } = usePosition(watch, settings);

  const cookLocation = () => {
    if (userinfo) {
      setCooksLocation({ ...userinfo?.location });
    }
  };
  useEffect(() => {
    dispatch(getCooks(isGuest ? meal.cook : meal.guest));
  }, [dispatch, isGuest, meal]);
  useEffect(cookLocation, [userinfo]);
  const date = moment(meal.consumptiondate.seconds * 1000).format('MM/DD/YYYY');
  const today = moment().format('MM/DD/YYYY');
  const checkdate = moment(today).isAfter(date);
  const userdetails = {
    ...userinfo,
  };
  const ArriveTime = arriveTimeDifference(meal.consumptiondate);
  // console.log('meal', meal);
  return (
    <div className="dashboard">
      <Row justify="center" className="order-details-container">
        <Col xs={24} sm={24} md={14} lg={10} xl={10}>
          <div className="details-cover-image">
            <Row justify="space-between" className="first-item">
              <Row>
                <img src={HAND} alt="hands" className="hand-icon" />
                <Typography.Text className="detail-text">
                  {t(meal.consumption)}
                </Typography.Text>
              </Row>
              <Row className="time-wrap">
                <GoClock
                  color={
                    meal.status === 'accepted' && !checkdate
                      ? '#00A75A'
                      : meal.status === 'waiting' && !checkdate
                      ? '#D34836'
                      : meal.status === 'refused'
                      ? '#9c9c9c'
                      : '#9c9c9c'
                  }
                  size={15}
                />
                <Typography.Text
                  className="detail-text"
                  style={{
                    color:
                      meal.status === 'accepted' && !checkdate
                        ? '#00A75A'
                        : meal.status === 'waiting' && !checkdate
                        ? '#D34836'
                        : meal.status === 'refused'
                        ? '#9c9c9c'
                        : '#9c9c9c',
                  }}
                >
                  {checkdate
                    ? moment(meal.consumptiondate.seconds * 1000).format(
                        'DD.MM.YYYY'
                      )
                    : meal.status === 'waiting'
                    ? t('Waiting for Accept')
                    : meal.status === 'refused'
                    ? t('Refused')
                    : isGuest
                    ? ArriveTime === ''
                      ? t('Ready')
                      : `${t('Ready in')} ${ArriveTime}`
                    : ArriveTime === ''
                    ? t('Ready')
                    : `${t('ARRIVE_IN')} ${ArriveTime}`}
                </Typography.Text>
              </Row>
            </Row>
            <img alt="example" src={meal.image} className="details-image" />
            <Row justify="space-between">
              <Col>
                <Typography.Text className="text-value">
                  {meal.portions}
                </Typography.Text>
                <Typography.Text className="detail-text">
                  {t('Quantity')}
                </Typography.Text>
              </Col>
              <Col>
                <Typography.Text className="totalprice-text">
                  {t('Total Price')}
                </Typography.Text>
                <Typography.Text className="price-value">
                  Kč {meal.ordertotal}
                </Typography.Text>
                {isGuest ? (
                  <div>
                    <Typography.Text className="totalprice-text">
                      {t('Your Payout')}
                    </Typography.Text>
                    <Typography.Text className="payout-value">
                      Kč {meal.ordertotal}
                    </Typography.Text>
                  </div>
                ) : null}
              </Col>
            </Row>
            <Col className="order-details-body">
              <Typography.Text className="title-text">
                {meal.title}
              </Typography.Text>
              <Typography.Text className="description-text">
                {meal.description}
              </Typography.Text>
            </Col>
            {/* {meal.refusedmessage === '' ||
            meal.refusedmessage === undefined ? null : (
              <Col className="order-details-body">
                <Typography.Text className="refused-text">
                  {`Cook's message: ${meal.refusedmessage}`}
                </Typography.Text>
              </Col>
            )} */}
          </div>
          <div className="separator" />
          <div>
            <Row justify="space-between" className="address-container">
              <Link
                to={{
                  pathname: '/userprofile/profile',
                  state: userdetails,
                }}
              >
                <Row>
                  <Avatar src={userinfo.image} size="small" />
                  <Typography.Text className="profile-text" ellipsis>
                    {userinfo.firstName}
                  </Typography.Text>
                </Row>
              </Link>
              <Row>
                <MdLocalPhone color="#27aae1" size={20} />
                <Typography.Text className="phone-number-text">
                  {userinfo.phone}
                </Typography.Text>
              </Row>
            </Row>
            <Row className="body-container">
              <Typography.Text className="address-text">
                {`${
                  userinfo.address.city !== undefined
                    ? userinfo.address.city
                    : ''
                }
                 ${
                   userinfo.address.note !== undefined
                     ? userinfo.address.note
                     : ''
                 }
                  ${
                    userinfo.address.street !== undefined
                      ? userinfo.address.street
                      : ''
                  }
                `}
              </Typography.Text>
              {!isGuest ? null : (
                <Row className="location-icon">
                  <GoLocation color="#B0B1B2" size={15} />
                  <Typography.Text className="location-text">
                    {calcCrow(
                      cooksLocation?.lat,
                      cooksLocation?.lng,
                      latitude,
                      longitude
                    ).toFixed(2)}{' '}
                    km
                  </Typography.Text>
                </Row>
              )}
            </Row>
          </div>
        </Col>
      </Row>
      {isGuest ? (
        <div>
          {/* <Button type="default" size="large" className="navigate-button">
            <Row justify="center">
              <TiLocationArrow size={22} color="#f7941d" />
              <Typography.Text className="navigate-text">
                Navigate
              </Typography.Text>
            </Row>
          </Button> */}
          <Map order={meal} />
        </div>
      ) : null}
    </div>
  );
};

export const Details: React.FC = () => {
  const location = useLocation();
  const { state } = location;
  return (
    <div className="dashboard">
      <OrderDetails meal={state} />
    </div>
  );
};
